import React, { useState, useEffect } from 'react';
import axios from 'axios';
import FormOrder from './FormOrder';
import FormRundown from './FormRundown';
import FormUndangan from './FormUndangan';

import logoTdc from '../image/logo-tdc.png';

const MarketingForm = ({ marketingNumber, phoneNumber }) => {
  const [formType, setFormType] = useState('Pemesanan');

  const [name, setName] = useState(localStorage.getItem('name') || '');
  const [phone, setPhone] = useState(localStorage.getItem('phone') || '');
  const [totalHarga, setTotalHarga] = useState(localStorage.getItem('totalHarga') || 0);
  const [downPayment, setDownPayment] = useState(localStorage.getItem('downPayment') || 0);
  const [sisaPembayaran, setSisaPembayaran] = useState(localStorage.getItem('sisaPembayaran') || 0);

  const [orderType, setOrderType] = useState(localStorage.getItem('orderType') || '');
  const [packageName, setPackageName] = useState(localStorage.getItem('packageName') || '');
  const [pax, setPax] = useState(localStorage.getItem('pax') || '');

  const [namaPria, setNamaPria] = useState(localStorage.getItem('namaPria') || '');
  const [namaWanita, setNamaWanita] = useState(localStorage.getItem('namaWanita') || '');
  const [igPria, setIgPria] = useState(localStorage.getItem('igPria') || '');
  const [igWanita, setIgWanita] = useState(localStorage.getItem('igWanita') || '');
  const [emailPria, setEmailPria] = useState(localStorage.getItem('emailPria') || '');
  const [emailWanita, setEmailWanita] = useState(localStorage.getItem('emailWanita') || '');
  
  const [akadAddress, setAkadAddress] = useState(localStorage.getItem('akadAddress') || '');
  const [akadMaps, setAkadMaps] = useState(localStorage.getItem('akadMaps') || '');
  const [akadDate, setAkadDate] = useState(localStorage.getItem('akadDate') || '');
  const [akadTime, setAkadTime] = useState(localStorage.getItem('akadTime') || '');
  const [resepsiAddress, setResepsiAddress] = useState(localStorage.getItem('resepsiAddress') || '');
  const [resepsiMaps, setResepsiMaps] = useState(localStorage.getItem('resepsiMaps') || '');
  const [resepsiDate, setResepsiDate] = useState(localStorage.getItem('resepsiDate') || '');
  const [resepsiTime, setResepsiTime] = useState(localStorage.getItem('resepsiTime') || '');
  
  const [menuPackage, setMenuPackage] = useState(localStorage.getItem('menuPackage') || '');
  const [igOrder, setIgOrder] = useState(localStorage.getItem('igOrder') || '');
  const [deliveryAddress, setDeliveryAddress] = useState(localStorage.getItem('deliveryAddress') || '');
  const [deliveryMaps, setDeliveryMaps] = useState(localStorage.getItem('deliveryMaps') || '');
  const [deliveryDate, setDeliveryDate] = useState(localStorage.getItem('deliveryDate') || '');
  const [deliveryTime, setDeliveryTime] = useState(localStorage.getItem('deliveryTime') || '');


  // Form Data Capeng
  const [capengName, setCapengName] = useState(localStorage.getItem('capengName') || '');
  const [eventDate, setEventDate] = useState(localStorage.getItem('eventDate') || '');
  const [izinMenikah, setIzinMenikah] = useState(localStorage.getItem('izinMenikah') || '');


  // Form Undangan Online
  const [demoUndangan, setDemoUndangan] = useState(localStorage.getItem('demoUndangan') || '');
  const [priaWanita, setPriaWanita] = useState(localStorage.getItem('priaWanita') || '');

  const [namaCpw, setNamaCpw] = useState(localStorage.getItem('namaCpw') || '');
  const [panggilanCpw, setPanggilanCpw] = useState(localStorage.getItem('panggilanCpw') || '');
  const [posisiCpw, setPosisiCpw] = useState(localStorage.getItem('posisiCpw') || '');
  
  const [namaCpp, setNamaCpp] = useState(localStorage.getItem('namaCpp') || '');
  const [panggilanCpp, setPanggilanCpp] = useState(localStorage.getItem('panggilanCpp') || '');
  const [posisiCpp, setPosisiCpp] = useState(localStorage.getItem('posisiCpp') || '');

  const [ayahCpw, setAyahCpw] = useState(localStorage.getItem('ayahCpw') || '');
  const [ibuCpw, setIbuCpw] = useState(localStorage.getItem('ibuCpw') || '');

  const [ayahCpp, setAyahCpp] = useState(localStorage.getItem('ayahCpp') || '');
  const [ibuCpp, setIbuCpp] = useState(localStorage.getItem('ibuCpp') || '');

  const [hariAkad, setHariAkad] = useState(localStorage.getItem('hariAkad') || '');
  const [jamAkad, setJamAkad] = useState(localStorage.getItem('jamAkad') || '');
  const [lokasiAkad, setLokasiAkad] = useState(localStorage.getItem('lokasiAkad') || '');
  const [mapsAkad, setMapsAkad] = useState(localStorage.getItem('mapsAkad') || '');

  const [hariResepsi, setHariResepsi] = useState(localStorage.getItem('hariResepsi') || '');
  const [jamResepsi, setJamResepsi] = useState(localStorage.getItem('jamResepsi') || '');
  const [lokasiResepsi, setLokasiResepsi] = useState(localStorage.getItem('lokasiResepsi') || '');
  const [mapsResepsi, setMapsResepsi] = useState(localStorage.getItem('mapsResepsi') || '');

  const [reqRomantis, setReqRomantis] = useState(localStorage.getItem('reqRomantis') || '');

  const [reqLagu, setReqLagu] = useState(localStorage.getItem('reqLagu') || '');

  const [sosmedCpw, setSosmedCpw] = useState(localStorage.getItem('sosmedCpw') || '');
  const [sosmedCpp, setSosmedCpp] = useState(localStorage.getItem('sosmedCpp') || '');

  const [amplopDigital, setAmplopDigital] = useState(localStorage.getItem('amplopDigital') || '');

  const [catatanUndangan, setCatatanUndangan] = useState(localStorage.getItem('catatanUndangan') || '');
  
  const [linkDrive, setLinkDrive] = useState(localStorage.getItem('linkDrive') || '');
  const [invitationLink, setInvitationLink] = useState(localStorage.getItem('invitationLink') || '');

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (formType === 'Pemesanan') {
      localStorage.setItem('name', name);
      localStorage.setItem('phone', phone);
      localStorage.setItem('totalHarga', totalHarga);
      localStorage.setItem('downPayment', downPayment);
      localStorage.setItem('sisaPembayaran', sisaPembayaran);

      localStorage.setItem('orderType', orderType);
      localStorage.setItem('packageName', packageName);
      localStorage.setItem('pax', pax);
      
      localStorage.setItem('namaPria', namaPria);
      localStorage.setItem('namaWanita', namaWanita);
      localStorage.setItem('igPria', igPria);
      localStorage.setItem('igWanita', igWanita);
      localStorage.setItem('emailPria', emailPria);
      localStorage.setItem('emailWanita', emailWanita);

      localStorage.setItem('akadAddress', akadAddress);
      localStorage.setItem('akadMaps', akadMaps);
      localStorage.setItem('akadDate', akadDate);
      localStorage.setItem('akadTime', akadTime);
      localStorage.setItem('resepsiAddress', resepsiAddress);
      localStorage.setItem('resepsiMaps', resepsiMaps);
      localStorage.setItem('resepsiDate', resepsiDate);
      localStorage.setItem('resepsiTime', resepsiTime);

      localStorage.setItem('menuPackage', menuPackage);
      localStorage.setItem('igOrder', igOrder);
      localStorage.setItem('deliveryAddress', deliveryAddress);
      localStorage.setItem('deliveryMaps', deliveryMaps);
      localStorage.setItem('deliveryDate', deliveryDate);
      localStorage.setItem('deliveryTime', deliveryTime);

    } else if (formType === 'Data Capeng') {
      localStorage.setItem('capengName', capengName);
      localStorage.setItem('eventDate', eventDate);

    } else if (formType === 'Undangan Online') {
      localStorage.setItem('demoUndangan', demoUndangan);
      localStorage.setItem('priaWanita', priaWanita);
      localStorage.setItem('namaCpw', namaCpw);
      localStorage.setItem('panggilanCpw', panggilanCpw);
      localStorage.setItem('posisiCpw', posisiCpw);
      localStorage.setItem('namaCpp', namaCpp);
      localStorage.setItem('panggilanCpp', panggilanCpp);
      localStorage.setItem('posisiCpp', posisiCpp);
      localStorage.setItem('ayahCpw', ayahCpw);
      localStorage.setItem('ibuCpw', ibuCpw);
      localStorage.setItem('ayahCpp', ayahCpp);
      localStorage.setItem('ibuCpp', ibuCpp);
      localStorage.setItem('hariAkad', hariAkad);

      localStorage.setItem('jamAkad', jamAkad);
      localStorage.setItem('lokasiAkad', lokasiAkad);
      localStorage.setItem('mapsAkad', mapsAkad);
      localStorage.setItem('hariResepsi', hariResepsi);

      localStorage.setItem('jamResepsi', jamResepsi);
      localStorage.setItem('lokasiResepsi', lokasiResepsi);
      localStorage.setItem('mapsResepsi', mapsResepsi);
      localStorage.setItem('reqRomantis', reqRomantis);
      localStorage.setItem('reqLagu', reqLagu);
      localStorage.setItem('sosmedCpw', sosmedCpw);
      localStorage.setItem('sosmedCpp', sosmedCpp);
      localStorage.setItem('amplopDigital', amplopDigital);
      localStorage.setItem('catatanUndangan', catatanUndangan);
      localStorage.setItem('linkDrive', linkDrive);
      localStorage.setItem('invitationLink', invitationLink);

    }
  }, [
    // pemesanan
    name, 
    phone, 

    totalHarga,
    downPayment,
    sisaPembayaran,
    orderType, 
    packageName, 
    pax,

    namaPria,
    namaWanita,
    igPria,
    igWanita,
    emailPria,
    emailWanita,
    
    akadMaps,
    resepsiMaps,

    akadAddress,
    resepsiAddress,
    akadDate,
    akadTime,
    resepsiDate,
    resepsiTime,

    menuPackage, 
    igOrder,
    deliveryAddress,
    deliveryMaps,
    deliveryDate,
    deliveryTime,
    
    // data capeng
    capengName, 
    eventDate, 

    // undangan online
    demoUndangan,
    priaWanita,
    namaCpw,
    panggilanCpw,
    posisiCpw,
    namaCpp,
    panggilanCpp,
    posisiCpp,
    ayahCpw,
    ibuCpw,
    ayahCpp,
    ibuCpp,
    hariAkad,

    jamAkad,
    lokasiAkad,
    mapsAkad,
    hariResepsi,

    jamResepsi,
    lokasiResepsi,
    mapsResepsi,
    reqRomantis,
    reqLagu,
    sosmedCpw,
    sosmedCpp,
    amplopDigital,
    catatanUndangan,
    linkDrive,
    invitationLink,

    formType]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return; // Prevent double submission

    setIsSubmitting(true); // Disable further submissions

    let formData = {};
    let whatsappLink = '';
    if (formType === 'Pemesanan') {
      formData = { 
        formType,
        marketing: marketingNumber,
        name,
        phone,
        totalHarga,
        downPayment,
        sisaPembayaran,
        orderType,
        packageName,
        pax,
        namaPria,
        namaWanita,
        igPria,
        igWanita,
        emailPria,
        emailWanita,
        akadAddress,
        akadMaps,
        resepsiAddress,
        resepsiMaps,
        akadDate,
        akadTime,
        resepsiDate,
        resepsiTime,
        menuPackage, 
        igOrder,
        deliveryAddress,
        deliveryMaps,
        deliveryDate,
        deliveryTime,
                
     };
        if (orderType === 'Wedding') {
          whatsappLink = `https://api.whatsapp.com/send?phone=62${phoneNumber}&text=%2AForm+Konfirmasi+Pemesanan%2A%0D%0A%F0%9F%91%A4+Nama+Pemesan%3A+%2A${name}%2A%0D%0A%F0%9F%93%B1+No.+Hp+%2F+WA%3A+%2A${phone}%2A%0D%0A%0D%0A%3E+%2APAKET+WEDDING+TIGA+DARA+CATERING%2A%0D%0APaket+Wedding%3A+%2A${packageName}%2A%0D%0AJumlah+Tamu%3A+%2A${pax}%2A%0D%0A%0D%0A%3E+Data+Calon+Pengantin%0D%0A%F0%9F%A4%B4+Nama+Mempelai+Pria%3A+%2A${namaPria}%2A%0D%0AIG+Mempelai+Pria%3A+%2A${igPria}%2A%0D%0AEmail+Mempelai+Pria%3A+%2A${emailPria}%2A%0D%0A%0D%0A%F0%9F%91%B8+Nama+Mempelai+Wanita%3A+%2A${namaWanita}%2A%0D%0AIG+Mempelai+Wanita%3A+%2A${igWanita}%2A%0D%0AEmail+Mempelai+Wanita%3A+%2A${emailWanita}%2A%0D%0A%0D%0A%3E+Lokasi+Acara%0D%0A%F0%9F%93%8D+Akad+%2F+Pemberkatan%3A+%2A${akadAddress}%2A%0D%0AShare+Location%3A+%2A${akadMaps}%2A%0D%0ATanggal+Akad%3A+%2A${akadDate}%2A%0D%0AJam+Akad%3A+%2A${akadTime}%2A%0D%0A%0D%0A%F0%9F%93%8D+Resepsi%3A+%2A${resepsiAddress}%2A%0D%0AShare+Location%3A+%2A${resepsiMaps}%2A%0D%0ATanggal+Resepsi%3A+%2A${resepsiDate}%2A%0D%0AJam+Resepsi%3A+%2A${resepsiTime}%2A%0D%0A%0D%0A%3E+Total+Harga%0D%0ATotal+Harga+Paket%3A+%2A${totalHarga}%2A%0D%0ADown+Payment%3A+%2A${downPayment}%2A%0D%0ASisa+Pembayaran%3A+%2A${sisaPembayaran}%2A%0D%0A%0D%0A%3E+Perhatian%0D%0A%2ASebelum+DP+Pastikan+Harga+Terbaru+yang+tertera+di+WEBSITE+bukan+di+BROSUR%2FKATALOG+dan+semua+uang+yang+sudah+kami+terima+tidak+dapat+dikembalikan+dengan+alasan+apapun+%28NO+REFUNABLE%29%2A%0D%0A%0D%0A%2APastikan+Jam+Pengiriman+%2F+Acara+sudah+sesuai%2C+perubahan+jam+pengiriman+%2F+acara+hanya+bisa+dilakukan+H-7+dan+dekorasi+dua+jam+sebelum+acara+dipastikan+sudah+rapih%2A%0D%0A%0D%0A%3E+Pembayaran%0D%0ASemua+Pembayaran+%2AWAJIB+TRANSFER%2A+%28No+Cash%2FTunai%29+ke+%3A+%0D%0A-+Nama+Rekening+%3A+Agustian%0D%0A-+No.+Rekening+%3A+7025122119%0D%0A-+Bank+%3A+BCA%0D%0A-+Cabang+%3A+Bumi+Permata+Meruya+Jakarta%0D%0A%0D%0A%2ANB%2A+%3A+MAKSIMAL+3+HARI+SETELAH+DP+MEMPELAI+WAJIB+MEMINTA+E-KONTRAK+DAN+KWITANSI+KEPADA+TEAM+MARKETING%0D%0A%0D%0A_Terima+Kasih+atas+kepercayaan+anda+kepada+Tiga+Dara+Catering+%26+Wedding+Organizer_%0D%0A%F0%9F%99%8F%F0%9F%99%8F%F0%9F%99%8F`;
        } else if (orderType === 'Nasi Box Prasmanan') {
          whatsappLink = `https://api.whatsapp.com/send?phone=62${phoneNumber}&text=%2AForm+Konfirmasi+Pemesanan%2A%0D%0A%F0%9F%91%A4+Nama+Pemesan%3A+%2A${name}%2A%0D%0A%F0%9F%93%B1+No.+Hp+%2F+WA%3A+%2A${phone}%2A%0D%0A%0D%0A%3E+Detail+Pesanan%0D%0ANama+Menu+%3A+%2A${menuPackage}%2A%0D%0AJumlah+Order%3A+%2A${pax}%2A+%2F+Pax+%2F+Box%0D%0A%0D%0A%F0%9F%93%8D+Alamat+Pengiriman+%2F+Acara%3A%0D%0A%2A${deliveryAddress}%2A%0D%0AShare+Location%3A%0D%0A%2A${deliveryMaps}%2A%0D%0ATanggal+Pengiriman+%2F+Acara%3A%0D%0A%2A${deliveryDate}%2A%0D%0AJam+Tiba+di+Lokasi+%2F+Acara%3A%0D%0A%2A${deliveryTime}%2A%0D%0AInstagram+Pemesan%2FAcara%3A%0D%0A%2A${igOrder}%2A%0D%0A%0D%0ATotal+Harga+Paket%3A+%2A${totalHarga}%2A%0D%0ADown+Payment%3A+%2A${downPayment}%2A%0D%0ASisa+Pembayaran%3A+%2A${sisaPembayaran}%2A%0D%0A%0D%0A%3E+Perhatian%0D%0A_%2ADP+Nasi+Box+dan+DP+Prasmanan+50%25+dari+total+order.+Pelunasan+Nasi+Box+sebelum+barang+diturunkan+dan+Pelunasan+Prasmanan+Maksimal+H-7.%2A_%0D%0A%0D%0A_%2APastikan+Jam+Pengiriman+sudah+sesuai%2C+perubahan+jam+pengiriman+hanya+bisa+dilakukan+H-7%2A_%0D%0A%0D%0ASemua+Pembayaran+WAJIB+TRANSFER%28+No+Cash%2FTunai+%29+ke+%3A+%0D%0A-+Nama+Rekening+%3A+Agustian%0D%0A%2A+No.+Rekening+%3A+7025122119%0D%0A%2A+Bank+%3A+BCA%0D%0A%2A+Cabang+%3A+Bumi+Permata+Meruya+Jakarta%0D%0A%0D%0A_%2ANB+%3A+SEMUA+UANG+YG+SUDAH+MASUK+TIDAK+DAPAT+DIKEMBALIKAN%2A_%0D%0A%0D%0A_Terima+Kasih+atas+kepercayaan+anda+kepada+Tiga+Dara+Catering+%26+Wedding+Organizer_%0D%0A%F0%9F%99%8F%F0%9F%99%8F%F0%9F%99%8F`;
        }
    } else if (formType === 'Data Capeng') {
      formData = { 
        capengName, 
        eventDate, 
        izinMenikah,
        marketing: `Marketing ${marketingNumber}`, 
        formType };
      whatsappLink = `https://api.whatsapp.com/send?phone=62${phoneNumber}&text=Halo%2C%0ASaya%20*${capengName}*%0ATanggal%20Acara%20*${eventDate}${izinMenikah}*`;
    } else if (formType === 'Undangan Online') {
      formData = { 
        formType,
        marketing: `Marketing ${marketingNumber}`,
        demoUndangan,
        priaWanita,
        namaCpw,
        panggilanCpw,
        posisiCpw,
        ayahCpw,
        ibuCpw,
        namaCpp,
        panggilanCpp,
        posisiCpp,
        ayahCpp,
        ibuCpp,
        hariAkad,
        jamAkad,
        lokasiAkad,
        mapsAkad,
        hariResepsi,
        jamResepsi,
        lokasiResepsi,
        mapsResepsi,
        reqRomantis,
        reqLagu,
        sosmedCpw,
        sosmedCpp,
        amplopDigital,
        catatanUndangan,
        linkDrive,
        invitationLink };
      whatsappLink = `https://api.whatsapp.com/send?phone=62${phoneNumber}&text=%3E+%2AFORMAT+UNDANGAN+ONLINE%2A%0D%0AFitur+Buku+Tamu+Digital+%3A+%2A${invitationLink}%2A%0D%0ANomor+Desain+Undangan+%3A+%2A${demoUndangan}%2A%0D%0A%60Nomor+Desain+silahkan+pilih+di+undangan.tigadaracatering.id%60%0D%0A%0D%0AUrutan+Mempelai+Dalam+Undangan+%3A+%2A${priaWanita}%2A%0D%0A%0D%0A%3E+Data+Calon+Pengantin+Wanita+%28CPW%29%0D%0ANama+Lengkap+%3A+%2A${namaCpw}%2A%0D%0ANama+Panggilan+%3A+%2A${panggilanCpw}%2A%0D%0APutri+Ke-+%2A${posisiCpw}%2A%0D%0ANama+Ayah+%3A+%2A${ayahCpw}%2A%0D%0ANama+Ibu+%3A+%2A${ibuCpw}%2A%0D%0A%0D%0A%3E+Data+Calon+Pengantin+Pria+%28CPP%29%0D%0ANama+Lengkap+%3A+%2A${namaCpp}%2A%0D%0ANama+Panggilan+%3A+%2A${panggilanCpp}%2A%0D%0APutra+Ke-+%2A${posisiCpp}%2A%0D%0ANama+Ayah+%3A+%2A${ayahCpp}%2A%0D%0ANama+Ibu+%3A+%2A${ibuCpp}%2A%0D%0A%0D%0A%3E+Waktu+%26+Tempat+Pelaksanaan+Akad%2FPemberkatan%0D%0AHari+%26+Tanggal+%3A+%2A${hariAkad}%2A%0D%0AJam+Acara+%3A+%2A${jamAkad}%2A%0D%0ALokasi+Acara+%3A+%2A${lokasiAkad}%2A%0D%0ALink+Google+Maps+%3A+%2A${mapsAkad}%2A%0D%0A%0D%0A%3E+Waktu+%26+Tempat+Pelaksanaan+Resepsi%0D%0AHari+%26+Tanggal+%3A+%2A${hariResepsi}%2A%0D%0AJam+Acara+%3A+%2A${jamResepsi}%2A%0D%0ALokasi+Acara+%3A+%2A${lokasiResepsi}%2A%0D%0ALink+Google+Maps+%3A+%2A${mapsResepsi}%2A%0D%0A%0D%0A%3E+Request+Kata-kata+romantis+%3A%0D%0A${reqRomantis}%0D%0A%0D%0A%3E+Request+Musik+Untuk+Backsound+Undangan+%3A%0D%0A${reqLagu}%0D%0A%0D%0A%3E+Sosial+Media+Mempelai+Wanita+%3A%0D%0A${sosmedCpw}%0D%0A%0D%0A%3E+Sosial+Media+Mempelai+Pria+%3A%0D%0A${sosmedCpp}%0D%0A%0D%0A%3E+Nomor+Rekening+Untuk+Amplop+Digital+%3A%0D%0A${amplopDigital}%0D%0A%0D%0A%3E+Catatan+Tambahan+Untuk+Undangan+%3A%0D%0A${catatanUndangan}%0D%0A%0D%0A%3E+Link+Foto+Cetak+%3A%0D%0A${linkDrive}%0D%0A%0D%0A%60Catatan+Foto+Undangan+%3A%60%0D%0A%601.+1+Pose+Foto+Sendiri+Mempelai+Pria+untuk+di+Profile%60%0D%0A%602.+1+Pose+Foto+Sendiri+Mempelai+Wanita+untuk+di+Profile%60%0D%0A%603.+Foto+Untuk+Gallery+Undangan+Max.+10+Foto++%28untuk+slide+show%29%60%0D%0A%604.+Foto+untuk+Undangan+dapat+dikirim+via+email+ke+fotoundangan%40tigadaracatering.id%60%0D%0A%605.+Foto+untuk+di+meja+galeri+foto+event+dapat+dikirim+via+email+ke+fotocetak%40tigadaracatering.id%60`;
    }

    try {
      // const response = await axios.post('http://localhost/clientform-tdc/api/submit.php', formData);
      const response = await axios.post('https://clientform.tigadaracatering.id/api/submit.php', formData);

      console.log(response.data);
      if (response.data.message) {
        // Clear localStorage after successful submit
        // if (formType === 'Pemesanan') {
        //   localStorage.removeItem('name');
        //   localStorage.removeItem('address');
        //   localStorage.removeItem('phone');
        //   localStorage.removeItem('orderType');
        //   localStorage.removeItem('packageName');
        //   localStorage.removeItem('menuPackage');
        // } else if (formType === 'Data Capeng') {
        //   localStorage.removeItem('capengName');
        //   localStorage.removeItem('eventDate');
        // } else if (formType === 'Undangan Online') {
        //   localStorage.removeItem('invitationLink');
        // }

        window.location.href = whatsappLink;
      } else {
        alert("There was an error saving your data. Please try again.");
      }
    } catch (error) {
      console.error("There was an error sending the data!", error);
      alert("There was an error sending your data. Please try again.");
    } finally {
      setIsSubmitting(false); // Re-enable submissions
    }
  };

  return (
    <div className='clientform'>
      <div className='clientform--head'>
        <div className='head__logo-title'>
          <div>
            <img src={logoTdc} alt='Logo Tiga Dara Catering'/>
          </div>
          <div>
            <h1>Client Form<span>.</span></h1>
          </div>
        </div>
        <p>Anda akan terhubung dengan Marketing <span>{marketingNumber}</span></p>
      </div>
      
      <form onSubmit={handleSubmit}>
        <fieldset>
          <legend>Silahkan Pilih Form:</legend>
          <div>
            <input
              type="radio"
              id="pemesanan"
              name="formType"
              value="Pemesanan"
              checked={formType === 'Pemesanan'}
              onChange={(e) => setFormType(e.target.value)}
            />
            <label htmlFor="pemesanan">Form Pemesanan</label>
          </div>
          {/* <div>
            <input
              type="radio"
              id="dataCapeng"
              name="formType"
              value="Data Capeng"
              checked={formType === 'Data Capeng'}
              onChange={(e) => setFormType(e.target.value)}
            />
            <label htmlFor="dataCapeng">Form Data Capeng</label>
          </div> */}
          <div>
            <input
              type="radio"
              id="undanganOnline"
              name="formType"
              value="Undangan Online"
              checked={formType === 'Undangan Online'}
              onChange={(e) => setFormType(e.target.value)}
            />
            <label htmlFor="undanganOnline">Form Undangan Online</label>
          </div>
        </fieldset>
        <hr />
        {formType === 'Pemesanan' && (
          <FormOrder
            name={name}
            setName={setName}
            phone={phone}
            setPhone={setPhone}
            totalHarga={totalHarga}
            setTotalHarga={setTotalHarga}
            downPayment={downPayment}
            setDownPayment={setDownPayment}
            sisaPembayaran={sisaPembayaran}
            setSisaPembayaran={setSisaPembayaran}
            orderType={orderType}
            setOrderType={setOrderType}
            packageName={packageName}
            setPackageName={setPackageName}
            pax={pax}
            setPax={setPax}
    
            namaPria={namaPria}
            setNamaPria={setNamaPria}
            namaWanita={namaWanita}
            setNamaWanita={setNamaWanita}

            igPria={igPria}
            setIgPria={setIgPria}
            igWanita={igWanita}
            setIgWanita={setIgWanita}

            emailPria={emailPria}
            setEmailPria={setEmailPria}
            emailWanita={emailWanita}
            setEmailWanita={setEmailWanita}

            akadAddress={akadAddress}
            setAkadAddress={setAkadAddress}
            akadMaps={akadMaps}
            setAkadMaps={setAkadMaps}
            resepsiAddress={resepsiAddress}
            setResepsiAddress={setResepsiAddress}
            resepsiMaps={resepsiMaps}
            setResepsiMaps={setResepsiMaps}
            akadDate={akadDate}
            setAkadDate={setAkadDate}
            akadTime={akadTime}
            setAkadTime={setAkadTime}
            resepsiDate={resepsiDate}
            setResepsiDate={setResepsiDate}
            resepsiTime={resepsiTime}
            setResepsiTime={setResepsiTime}

            menuPackage={menuPackage}
            setMenuPackage={setMenuPackage}
            igOrder={igOrder}
            setIgOrder={setIgOrder}
            deliveryAddress={deliveryAddress}
            setDeliveryAddress={setDeliveryAddress}
            deliveryMaps={deliveryMaps}
            setDeliveryMaps={setDeliveryMaps}
            deliveryDate={deliveryDate}
            setDeliveryDate={setDeliveryDate}
            deliveryTime={deliveryTime}
            setDeliveryTime={setDeliveryTime}
            
          />
        )}
        {formType === 'Data Capeng' && (
          <FormRundown
            capengName={capengName}
            setCapengName={setCapengName}
            eventDate={eventDate}
            setEventDate={setEventDate}
            izinMenikah={izinMenikah}
            setIzinMenikah={setIzinMenikah}
          />
        )}
        {formType === 'Undangan Online' && (
          <FormUndangan
            demoUndangan={demoUndangan}
            setDemoUndangan={setDemoUndangan}
            priaWanita={priaWanita}
            setPriaWanita={setPriaWanita}
            namaCpw={namaCpw}
            setNamaCpw={setNamaCpw}
            panggilanCpw={panggilanCpw}
            setPanggilanCpw={setPanggilanCpw}
            posisiCpw={posisiCpw}
            setPosisiCpw={setPosisiCpw}
            namaCpp={namaCpp}
            setNamaCpp={setNamaCpp}
            panggilanCpp={panggilanCpp}
            setPanggilanCpp={setPanggilanCpp}
            posisiCpp={posisiCpp}
            setPosisiCpp={setPosisiCpp}
            ayahCpw={ayahCpw}
            setAyahCpw={setAyahCpw}
            ibuCpw={ibuCpw}
            setIbuCpw={setIbuCpw}
            ayahCpp={ayahCpp}
            setAyahCpp={setAyahCpp}
            ibuCpp={ibuCpp}
            setIbuCpp={setIbuCpp}
            hariAkad={hariAkad}
            setHariAkad={setHariAkad}
            jamAkad={jamAkad}
            setJamAkad={setJamAkad}
            lokasiAkad={lokasiAkad}
            setLokasiAkad={setLokasiAkad}
            mapsAkad={mapsAkad}
            setMapsAkad={setMapsAkad}
            hariResepsi={hariResepsi}
            setHariResepsi={setHariResepsi}
            jamResepsi={jamResepsi}
            setJamResepsi={setJamResepsi}
            lokasiResepsi={lokasiResepsi}
            setLokasiResepsi={setLokasiResepsi}
            mapsResepsi={mapsResepsi}
            setMapsResepsi={setMapsResepsi}
            reqRomantis={reqRomantis}
            setReqRomantis={setReqRomantis}
            reqLagu={reqLagu}
            setReqLagu={setReqLagu}
            sosmedCpw={sosmedCpw}
            setSosmedCpw={setSosmedCpw}
            sosmedCpp={sosmedCpp}
            setSosmedCpp={setSosmedCpp}
            amplopDigital={amplopDigital}
            setAmplopDigital={setAmplopDigital}
            catatanUndangan={catatanUndangan}
            setCatatanUndangan={setCatatanUndangan}
            linkDrive={linkDrive}
            setLinkDrive={setLinkDrive}
            invitationLink={invitationLink}
            setInvitationLink={setInvitationLink}
          />
        )}

        <button type="submit" disabled={isSubmitting}>Submit</button>
      </form>
    </div>
  );
};

export default MarketingForm;
